import styled from 'styled-components';

import {
  TextArea as SemanticTextArea,
} from 'semantic-ui-react';

export const QuestionLabel = styled.span`
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 15px;'};
  ${({ theme }) => theme && theme.text};
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  user-select: text;
  font-weight: 500;
  padding-bottom: 15px;
  display: flex;
`;

export const QuestionAnswerLabel = styled.span`
  color: #172B4D;
  padding-bottom: 15px;
  display: flex;
  text-align: left;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  word-wrap: break-word;
  margin-top: 15px;
  padding: 10px;
  overflow: auto;
`;

export const BreakLine = styled.hr`
  margin: 10px 10px 0 10px;
  border-style: ridge;
`;

export const Label = styled.span`
  font-size: 14px;
  color: #192C47;
  margin: 0px auto 2px 5px;
`;

export const TextArea = styled(SemanticTextArea)`
  flex-grow: 1;
  resize: vertical;
  border-radius: 10px;
  padding: 10px;
  min-height: 20px;

  &&&&.ui.disabled.input,
  &&&&.ui.input:not(.disabled) input[disabled] {
    color: black;
    opacity: 1;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
